/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The severity of a comment.
 */
export const QualityCommentSeverity = /* #__PURE__ */ parsers.exactly('info', 'warning', 'error', 'fatal');
